export default require('./Tab').default
